import React from "react";
import { Typography } from "@mui/material";

const About = () => {
    return <Typography variant="h4">about...</Typography>;
};

export default About;
